import { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Button, Form, ListGroup } from 'react-bootstrap';
import { useForgotPasswordMutation } from '../../../features/authentication/authApiSlice';
import { useNavigate } from 'react-router';
import HesSpinner from '../../../components/loadingOverlay/hesSpinner';
import Modal from '../../../components/Modal/index';

function ReactComponent() {
  const accountEmailRef = useRef();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    try {
      setError('');
      await forgotPassword(accountEmailRef.current.value).unwrap();
      setShowModal(true);
    } catch (ex) {
      if (ex && (ex.status == 500 || ex.status === 'FETCH_ERROR')) {
        setError('Something went wrong, could not connect to server');
      } else {
        setShowModal(true);
      }
    }
  }

  return (
    <>
      <ListGroup className="login-card-body" variant="flush">
        <ListGroup.Item>
          <div
            className="mx-auto text-color"
            style={{
              width: '90%',
              textAlign: 'center',
              fontWeight: '500',
              fontSize: '18px'
            }}>
            Forgot/Reset Password
          </div>
        </ListGroup.Item>
        <ListGroup.Item>
          <div className="mx-auto mb-4" style={{ width: '90%', textAlign: 'center' }}>
            We can email a secure link to reset your Castle Learning Password to you if you have
            previously specified your email address in your Castle Learning Profile.
          </div>
        </ListGroup.Item>

        <Form onSubmit={handleSubmit}>
          <ListGroup.Item>
            <Form.Group id="userName">
              <Form.Label>Email (primary or secondary)</Form.Label>
              <div>
                <Form.Control
                  className="loginTextBox"
                  type="email"
                  ref={accountEmailRef}
                  required
                />
                <FontAwesomeIcon className="loginTextboxIcon" icon={faEnvelope} />
              </div>
            </Form.Group>
          </ListGroup.Item>

          <ListGroup.Item>
            <Button disabled={isLoading} variant="castleRed" className="submitButton" type="submit">
              {isLoading && <div style={{ position: 'absolute', top: '14px', bottom: '14px', left: '25%' }}><HesSpinner /></div>}
              Email the secure link to me
            </Button>
          </ListGroup.Item>
        </Form>

        {error && (
          <ListGroup.Item>
            <div className="d-flex flex-column align-content-center">
              <div className='mx-auto error'>
                {error}
              </div>
              <div className='mx-auto text-color'>
                Please try again or contact customer support at 800-345-7606
              </div>
            </div>
          </ListGroup.Item>
        )}

        <ListGroup.Item>
          <div className="mx-auto mb-1 mt-3" style={{ width: '90%', textAlign: 'center' }}>
            Please call Customer Support at 800-345-7606 if you have not specified your email
            address in your Profile or a teacher is not available.
          </div>
        </ListGroup.Item>

        <ListGroup.Item>
          <Button
            variant="castleWhite"
            className="backButton"
            onClick={() => navigate('/login')}>
            Back to Login
          </Button>
        </ListGroup.Item>
      </ListGroup>

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        titleName='Reset password'
        contentWidth='40%'>
        <div className='d-flex flex-column'>
          <p>
            If there is an account associated with the email that was provided a reset link has been
            sent
          </p>
          <div className='d-flex flex-row justify-content-end'>
            <Button variant="castleRed" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </div>

        </div>
      </Modal>
    </>
  );
}

export default ReactComponent;
